"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils = __importStar(require("./columnUtils"));
const BaseColumn_1 = require("./BaseColumn");
const Style_1 = require("../style/Style");
class Column extends BaseColumn_1.BaseColumn {
    get StyleClass() {
        return Style_1.Style;
    }
    clone() {
        return new Column(this);
    }
    drawInternal(value, context, style, helper, _grid, { drawCellBase, getIcon }) {
        const { textAlign, textBaseline, color, font, bgColor, padding, textOverflow, } = style;
        if (bgColor) {
            drawCellBase({
                bgColor,
            });
        }
        helper.testFontLoad(font, value, context);
        utils.loadIcons(getIcon(), context, helper, (icons, context) => {
            helper.text(value, context, {
                textAlign,
                textBaseline,
                color,
                font,
                padding,
                textOverflow,
                icons,
            });
        });
    }
}
exports.Column = Column;
